import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import back_n from "../Tutorials/Image/back_n.gif";
import back_o from "../Tutorials/Image/back_o.gif";
import back_d from "../Tutorials/Image/back_d.gif";
import principle_n from "../Tutorials/Image/principle_n.gif";
import tutorials_n from "../Tutorials/Image/tutorials_n.gif";
import clue_n from "../Tutorials/Image/clue_n.gif";
import solution_n from "../Tutorials/Image/solution_n.gif";
import solution_o from "../Tutorials/Image/solution_o.gif";
import solution_d from "../Tutorials/Image/solution_d.gif";
import next_n from "../Tutorials/Image/next_n.gif";
import next_o from "../Tutorials/Image/next_o.gif";
import next_d from "../Tutorials/Image/next_d.gif";
import ok_n from "../Tutorials/Image/ok_n.gif";
import ok_o from "../Tutorials/Image/ok_o.gif";
import ok_d from "../Tutorials/Image/ok_d.gif";
import done_o from "../Tutorials/Image/done_o.gif";
import done_n from "../Tutorials/Image/done_n.gif";
import x_close_btn_n from "../Tutorials/Image/x_close_btn_n.png";
import x_close_btn_o from "../Tutorials/Image/x_close_btn_o.png";
import next_step_btn_n from "../Tutorials/Image/next_step_btn_n.png";
import next_step_btn_o from "../Tutorials/Image/next_step_btn_o.png";
import got_it_btn_n from "../Tutorials/Image/got_it_btn_n.png";
import got_it_btn_o from "../Tutorials/Image/got_it_btn_o.png";
import './Style/Question.css';
import Loading from "../../Common/Loading";
import { buildNextQuestionData, buildOptionOrder, buildShuffledQuestionsOrder, saveQuestionPerformance, QuestionPerformancePayload } from '../../services/questionApi';

export interface AnswerRef {
  getAnswer: () => {
    marks: number;
    noOfOptions: number;
    enteredCorrectAnswer: string;
    enteredWrongAnswer: string;
    enteredBlankAnswer: string;
    scoringMethod?: number | null;
    optOrder?: string;
  } | null;
  getSkipMetadata?: () => { noOfOptions: number; optOrder: string } | null;
}

interface ValidationResult {
  marks: number;
  noOfOptions: number;
  enteredCorrectAnswer: string;
  enteredWrongAnswer: string;
  enteredBlankAnswer: string;
  scoringMethod?: number | null;
  optOrder?: string;
  correctAnswerText: string;
}

interface OQnsProps {
  lessonMeta?: any;
  questionHtml: string;
  currentPage: number;
  totalPages: number;
  goToNextPage?: (e: React.MouseEvent) => void;
  showAlert: (message: string) => void;
  correctAudio: string[];
  incorrectAudio: string[];
  assetsBaseUrl?: string;
  sessionId: number | null;
  isCompleting?: boolean;
  updateSessionPoints?: (pointsEarned: number) => void;
  hwid?: number | null;
  subject?: string;
  // Optional — passed by Question.tsx when it can. OQns does NOT rely on
  // this alone; it also parses PreviewMode from the URL itself below, so
  // this feature keeps working even if a parent prop chain gets missed.
  previewMode?: string | null;
}

const OQns: React.ForwardRefRenderFunction<AnswerRef, OQnsProps> = (props, ref) => {
  const { lessonMeta, questionHtml, currentPage, totalPages, goToNextPage, showAlert, correctAudio, incorrectAudio, assetsBaseUrl, sessionId, isCompleting, updateSessionPoints, hwid, subject, previewMode } = props;
  const navigate = useNavigate();
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const solnIframeRef = useRef<HTMLIFrameElement>(null);
  const clueIframeRef = useRef<HTMLIFrameElement>(null);
  const prcIframeRef = useRef<HTMLIFrameElement>(null);
  // The question markup lives in an iframe and its feedback is applied
  // imperatively. Keep a snapshot so a reload while opening a solution does
  // not erase the student's validation result.
  const validationRef = useRef<ValidationResult | null>(null);

  const [backSrc, setBackSrc] = useState(back_n);
  const [nextSrc, setNextSrc] = useState(next_n);
  const [okSrc, setOkSrc] = useState(ok_n);
  const [doneSrc, setDoneSrc] = useState(done_n);
  const [solutionSrc, setSolutionSrc] = useState(solution_n);
  const [CloseBtnSrc, setCloseBtnSrc] = useState(x_close_btn_n);
  const [NextStepBtnSrc, setNextStepBtnSrc] = useState(next_step_btn_n);
  const [GotItBtnSrc, setGotItBtnSrc] = useState(got_it_btn_n);

  const [okClicked, setOkClicked] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [currentQnMeta, setCurrentQnMeta] = useState<any | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [startTime, setStartTime] = useState<Date | null>(null);

  const [showClueModal, setShowClueModal] = useState(false);
  const [clueContent, setClueContent] = useState('');
  const [isClueLoading, setIsClueLoading] = useState(false);
  const [noOfClues, setNoOfClues] = useState(0);
  const [currentClueNo, setCurrentClueNo] = useState(0);
  const [clueSeen, setClueSeen] = useState(false);

  const [showPrcModal, setShowPrcModal] = useState(false);
  const [prcContent, setPrcContent] = useState("");
  const [isPrcLoading, setIsPrcLoading] = useState(false);
  const [prcSeen, setPrcSeen] = useState(false);
  const [principleList, setPrincipleList] = useState<string[]>([]);
  const [currentPrcIndex, setCurrentPrcIndex] = useState(0);

  const [showSolnModal, setShowSolnModal] = useState(false);
  const [isSolnLoading, setIsSolnLoading] = useState(false);
  const [solnContent, setSolnContent] = useState("");
  const [currentSolnNo, setCurrentSolnNo] = useState(0);
  const [noOfSteps, setNoOfSteps] = useState(0);
  const [solutionSeen, setSolutionSeen] = useState<string | number>('N');

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const folderParam = params.get('folder');
  const lessonName = params.get('name');
  const diccode = params.get('diccode');
  const calledFrom = params.get('calledFrom');
  const isInAssessment = window.location.href.includes('Assessment');

  // FIX: don't depend solely on the previewMode prop making it all the way
  // down from Question.tsx — read it straight off the URL too, the same
  // way this component already reads folder/name/diccode above. Whichever
  // one is present wins; real students have neither.
  const urlPreviewMode = params.get('PreviewMode');
  const effectivePreviewMode = previewMode || urlPreviewMode || null;
  const isRfcRfic = effectivePreviewMode === 'RFC_RFIC';

  const handleNextStepBtnMouseOver = () => setNextStepBtnSrc(next_step_btn_o);
  const handleNextStepBtnMouseOut = () => setNextStepBtnSrc(next_step_btn_n);
  const handleGotItBtnMouseOver = () => setGotItBtnSrc(got_it_btn_o);
  const handleGotItBtnMouseOut = () => setGotItBtnSrc(got_it_btn_n);
  const handleCloseBtnMouseOver = () => setCloseBtnSrc(x_close_btn_o);
  const handleCloseBtnMouseOut = () => setCloseBtnSrc(x_close_btn_n);
  const handleBackMouseOver = () => setBackSrc(back_o);
  const handleBackMouseOut = () => setBackSrc(back_n);
  const handleBackMouseDown = () => setBackSrc(back_d);
  const handleBackMouseUp = () => setBackSrc(back_o);
  const handleNextMouseOver = () => setNextSrc(next_o);
  const handleNextMouseOut = () => setNextSrc(next_n);
  const handleNextMouseDown = () => setNextSrc(next_d);
  const handleNextMouseUp = () => setNextSrc(next_o);
  const handleOkMouseOver = () => setOkSrc(ok_o);
  const handleOkMouseOut = () => setOkSrc(ok_n);
  const handleOkMouseDown = () => setOkSrc(ok_d);
  const handleOkMouseUp = () => setOkSrc(ok_o);
  const handleSolutionMouseOver = () => setSolutionSrc(solution_o);
  const handleSolutionMouseOut = () => setSolutionSrc(solution_n);
  const handleSolutionMouseDown = () => setSolutionSrc(solution_d);

  const injectObjectiveBridge = (html: string, assetBaseFromProps?: string): string => {
    const normalizedAssetBase = (() => {
      if (assetBaseFromProps && assetBaseFromProps.trim().length > 0) {
        return assetBaseFromProps.endsWith("/") ? assetBaseFromProps : `${assetBaseFromProps}/`;
      }
      return "";
    })();

    let cleaned = html
      .replace(/onmousemove="[^"]*"/gi, "")
      .replace(/<script[\s\S]*?<\/script>/gi, "");

    const bridge = `
    <style>
      body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
      p { margin: 0; padding: 0; }
      table { border-collapse: collapse; }
      
      td[id^="KSD_TD_"] { cursor: pointer; } 
      tr[id^="KSD_TR_"] { cursor: pointer; }
      table[id^='KSD_TABLE'] {
        border-collapse: separate !important;
      }
    </style>
    <script>
      (function() {
        const reactAssetBase = ${JSON.stringify(normalizedAssetBase)};
        const defaultAssetBase = "https://www.elearnoncloud.com/Storage/assets/";

        function normalizeBase(base) {
          if (!base) { return ""; }
          return base.endsWith("/") ? base : base + "/";
        }

        function resolveAssetBase() {
          const blobInput = document.getElementById("hidBlobAssetsPath");
          const blobValue = blobInput && blobInput.value ? blobInput.value.trim() : "";
          const fallback = reactAssetBase && reactAssetBase.trim().length > 0 ? reactAssetBase : defaultAssetBase;
          return normalizeBase(blobValue || fallback);
        }

        function configureObjectiveBackgrounds(assetBase, optionsTable) {
          try {
            const infoInput = document.getElementById("KSD_MW_Info");
            const infoValue = infoInput && infoInput.value ? infoInput.value : "";
            const infoParts = infoValue.split("|");
            const optionImageType = infoParts.length >= 9 ? parseInt(infoParts[8], 10) : NaN;

            const mapping = {
              2: { normal: "large_objective_n.png", selected: "large_objective_d.png" },
              3: { normal: "medium_objective_n.png", selected: "medium_objective_d.png" },
              4: { normal: "small_objective_n.png", selected: "small_objective_d.png" },
              5: { normal: "large_objective_shortened_n.png", selected: "large_objective_shortened_d.png" },
              6: { normal: "medium_objective_shortened_n.png", selected: "medium_objective_shortened_d.png" },
              7: { normal: "small_objective_shortened_n.png", selected: "small_objective_shortened_d.png" }
            };

            const files = mapping[optionImageType];
            if (!files) {
              optionsTable.removeAttribute("data-normal-bg");
              optionsTable.removeAttribute("data-selected-bg");
              return;
            }

            const normalBgUrl = assetBase + "Image/Questions/EL_O/" + files.normal;
            const selectedBgUrl = assetBase + "Image/Questions/EL_O/" + files.selected;
            optionsTable.setAttribute("data-normal-bg", normalBgUrl);
            optionsTable.setAttribute("data-selected-bg", selectedBgUrl);

            const divider = document.getElementById("KSD_DIVIDERBAR");
            if (divider) {
              divider.style.backgroundImage = "url(" + assetBase + "Image/Questions/EL_O/divider_bar.png)";
              divider.style.backgroundRepeat = "no-repeat";
            }
          } catch (err) {
            console.warn("Failed to configure option backgrounds:", err);
          }
        }

        function bridgeLogic() {
          try {
            const optionsTable = document.querySelector("table[id^='KSD_TABLE']");
            if (!optionsTable) { 
              setTimeout(bridgeLogic, 50);
              return; 
            }

            // Match EL_O.js: image-backed options use cellspacing=10 and cellpadding=5.
            const questionInfo = document.getElementById("KSD_MW_Info");
            const optionImageType = parseInt(questionInfo?.value?.split("|")[8] || "", 10);
            if (optionImageType >= 2) {
              optionsTable.setAttribute("cellspacing", "10");
              optionsTable.setAttribute("cellpadding", "5");
              optionsTable.style.setProperty("border-collapse", "separate", "important");
              optionsTable.style.setProperty("border-spacing", "10px", "important");
            }

            const assetBase = resolveAssetBase();
            if (assetBase) {
              configureObjectiveBackgrounds(assetBase, optionsTable);
            }

            const normalBgUrl = optionsTable.getAttribute('data-normal-bg');
            const selectedBgUrl = optionsTable.getAttribute('data-selected-bg');
            let selectedOptionElement = null;

            const options = Array.from(document.querySelectorAll('tr[id^="KSD_TR_"]'));

            options.forEach((row) => {
              const optionCell = row.querySelector('td[id^="KSD_TD_"]');
              const radio = row.querySelector('input[id^="KSD_Rad_"]');
              
              const contentCell = row.querySelector('td[id="KSD_TD2"]');
              if (contentCell) {
                contentCell.style.textAlign = 'center';
                contentCell.style.verticalAlign = 'middle';
                if (optionImageType >= 2) {
                  contentCell.style.setProperty('white-space', 'nowrap', 'important');
                }
              }
              
              const postableValue = (radio ? radio.getAttribute('name') : null);
              
              if (!optionCell || postableValue === null) {
                console.warn("OQns Bridge: Skipping row, missing cell or radio/name.", row);
                return;
              }

              if (normalBgUrl) {
                optionCell.style.backgroundImage = 'url(' + normalBgUrl + ')';
                optionCell.style.backgroundRepeat = 'no-repeat';
              }

              const clickHandler = (e) => {
                e.stopPropagation();
                e.preventDefault();
                
                if (selectedOptionElement && selectedOptionElement !== optionCell) {
                  if (normalBgUrl) selectedOptionElement.style.backgroundImage = 'url(' + normalBgUrl + ')';
                }
                
                if (selectedBgUrl) optionCell.style.backgroundImage = 'url(' + selectedBgUrl + ')';
                selectedOptionElement = optionCell;
                if (radio) {
                  radio.checked = true;
                  radio.dispatchEvent(new Event('change', { bubbles: true }));
                }

                parent.postMessage({ type: 'el-option-selected', value: postableValue }, '*');
              };

              row.addEventListener('click', clickHandler);
            });
          } catch(e) { console.error("Bridge Error:", e); }
        }
        
        bridgeLogic();
      })();
    </script>
  `;
    return cleaned.includes("</body>") ? cleaned.replace("</body>", bridge + "</body>") : cleaned + bridge;
  };

  useEffect(() => {
    setSelectedOption(null);
    setOkClicked(false);
    validationRef.current = null;
    setStartTime(new Date());
    setSolutionSeen('N');
    setClueSeen(false);
    setPrcSeen(false);
    if (lessonMeta?.qns) {
      setCurrentQnMeta(lessonMeta.qns[currentPage - 1]);
    }
  }, [currentPage, lessonMeta]);

  useEffect(() => {
    const iframe = solnIframeRef.current;
    if (!iframe) return;

    const adjustHeight = () => {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!doc) return;

        const totalHeight = doc.body.scrollHeight;
        iframe.style.height = totalHeight + "px";
      } catch (err) {
        console.error("Solution iframe height adjust error:", err);
      }
    };

    iframe.onload = adjustHeight;

    const t = setTimeout(adjustHeight, 300);
    return () => clearTimeout(t);
  }, [solnContent]);


  // ── Preview-mode only: RFC/RFIC reveal. Mirrors Question.js's rfcrfic()
  // + the "explanationmsg" injection block — shows every option's reasoning
  // at once (correct option's reasoning first, labeled RFC; the rest
  // labeled RFIC), instead of the single post-answer explanation. Retries
  // for the same reason revealCorrectAnswer does: the bridge script paints
  // asynchronously.
  const revealRfcRfic = useCallback((iframeDoc: Document, attempt: number = 0) => {
    const infoEl = iframeDoc.getElementById('KSD_MW_Info') as HTMLInputElement | null;
    const infoParts = infoEl?.value?.split('|') || [];
    const correctOptionIndex = infoParts.length > 3 ? infoParts[3].trim() : '';

    const rsnElements = Array.from(iframeDoc.querySelectorAll('[id^="TD_Rsn_"]')) as HTMLElement[];

    if ((!correctOptionIndex || rsnElements.length === 0) && attempt < 15) {
      setTimeout(() => revealRfcRfic(iframeDoc, attempt + 1), 100);
      return;
    }
    if (!correctOptionIndex || rsnElements.length === 0) {
      console.warn("RFC/RFIC preview: could not resolve reasoning elements.");
      return;
    }

    const letters = ["A", "B", "C", "D", "E", "F"];
    const items = rsnElements
      .map((el, i) => {
        const idSuffix = el.id.replace('TD_Rsn_', '');
        const html = el.innerHTML.trim();
        return html ? { id: idSuffix, letter: letters[i] || String(i), content: html } : null;
      })
      .filter((x): x is { id: string; letter: string; content: string } => x !== null);

    const correctItemIndex = items.findIndex(item => item.id === correctOptionIndex);
    if (correctItemIndex > -1) {
      const [correctItem] = items.splice(correctItemIndex, 1);
      items.unshift(correctItem);
    }

    if (items.length === 0) return;

    const firstHtml = items[0].content;
    const remainingHtml = items
      .slice(1)
      .map(item => `<span style="font-family:serif;font-style:italic">Option ${item.letter}</span><br>${item.content}<br>`)
      .join('');

    const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";

    const rows = iframeDoc.querySelectorAll('tr[id^="KSD_TR_"]');
    rows.forEach(row => {
      (row as HTMLElement).style.pointerEvents = 'none';
      const radio = row.querySelector('input[id^="KSD_Rad_"]');
      const optionIndex = radio ? radio.getAttribute('name') : null;
      if (optionIndex === null) return;

      const feedbackCell = row.querySelector(`td[id^="KSD_TDANS_${optionIndex}"]`);
      if (!feedbackCell) return;

      if (optionIndex === correctOptionIndex) {
        feedbackCell.innerHTML = `<img src="${CORRECT_URL}" alt="Correct" style="vertical-align: middle;" />`;
        (feedbackCell as HTMLElement).style.display = 'table-cell';
        (feedbackCell as HTMLElement).style.textAlign = 'center';
        (feedbackCell as HTMLElement).style.verticalAlign = 'middle';
      }
    });

    if (!iframeDoc.getElementById("el-explanation-container")) {
      const container = iframeDoc.createElement("div");
      container.id = "el-explanation-container";
      container.innerHTML = `
      <hr style='height:1px; background-color:#cfcfcf; border:none; margin-top:50px; margin-bottom:30px; margin-left:30px; margin-right:30px;'>
      <p style='font-size:24px; color:#797979; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:20px'>Explanation</p>
      <p style='font-size:24px; color:#000000; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding-left:30px; padding-right:30px; margin-top:0px; margin-bottom:50px'>
        <span style="font-weight:bold"> RFC</span><br>${firstHtml}<br><span style="font-weight:bold">${remainingHtml ? 'RFIC' : ''}</span><br>${remainingHtml}
      </p>
    `;
      iframeDoc.body.appendChild(container);
      setTimeout(() => {
        iframeDoc.documentElement.scrollTop = iframeDoc.documentElement.scrollHeight;
      }, 100);
    }

    setSelectedOption(correctOptionIndex);
    setOkClicked(true);

    const radio = iframeDoc.querySelector(
      `input[id^="KSD_Rad_"][name="${correctOptionIndex}"]`
    ) as HTMLInputElement | null;
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Preview-mode only: mark the correct answer + auto-open solution.
  // Retries because the bridge script above paints KSD_TDANS_* cells
  // asynchronously (it polls for table readiness itself) — if we look for
  // them the instant the iframe "load" event fires, they may not exist yet.
  const revealCorrectAnswer = useCallback((iframeDoc: Document, attempt: number = 0) => {
    const answerKeyInput = iframeDoc.getElementById('KSD_Ans') as HTMLInputElement | null;
    let correctAnswer = answerKeyInput?.value?.trim() || '';

    if (!correctAnswer) {
      const infoEl = iframeDoc.getElementById('KSD_MW_Info') as HTMLInputElement | null;
      const parts = infoEl?.value?.split('|') || [];
      correctAnswer = parts.length > 3 ? parts[3].trim() : '';
    }

    const rows = iframeDoc.querySelectorAll('tr[id^="KSD_TR_"]');

    if ((!correctAnswer || rows.length === 0) && attempt < 15) {
      setTimeout(() => revealCorrectAnswer(iframeDoc, attempt + 1), 100);
      return;
    }
    if (!correctAnswer) {
      console.warn("Preview mode: could not resolve the correct answer for this question.");
      return;
    }

    const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";

    rows.forEach(row => {
      (row as HTMLElement).style.pointerEvents = 'none';
      const radio = row.querySelector('input[id^="KSD_Rad_"]');
      const optionIndex = radio ? radio.getAttribute('name') : null;
      if (optionIndex === null) return;

      const feedbackCell = row.querySelector(`td[id^="KSD_TDANS_${optionIndex}"]`);
      if (!feedbackCell) return;

      if (optionIndex === correctAnswer) {
        feedbackCell.innerHTML = `<img src="${CORRECT_URL}" alt="Correct" style="vertical-align: middle;" />`;
        (feedbackCell as HTMLElement).style.display = 'table-cell';
        (feedbackCell as HTMLElement).style.textAlign = 'center';
        (feedbackCell as HTMLElement).style.verticalAlign = 'middle';
      }
    });

    setSelectedOption(correctAnswer);
    window.postMessage(
      {
        type: "el-option-selected",
        value: correctAnswer,
      },
      "*"
    );
    setOkClicked(true);

    const radio = iframeDoc.querySelector(
      `input[id^="KSD_Rad_"][name="${correctAnswer}"]`
    ) as HTMLInputElement | null;

    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (effectivePreviewMode === 'SOLUTION') {
      handleSolnClick(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effectivePreviewMode]);

  const applyValidationFeedback = useCallback((iframeDoc: Document, result: ValidationResult) => {
    const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";
    const WRONG_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsWrong.GIF";
    const SHOULD_BE_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsShouldbe.GIF";

    iframeDoc.querySelectorAll('tr[id^="KSD_TR_"]').forEach(row => {
      (row as HTMLElement).style.pointerEvents = 'none';
      const optionIndex = row.querySelector('input[id^="KSD_Rad_"]')?.getAttribute('name');
      if (optionIndex === null || optionIndex === undefined) return;

      const feedbackCell = row.querySelector(`td[id^="KSD_TDANS_${optionIndex}"]`) as HTMLElement | null;
      if (!feedbackCell) return;

      let feedbackImage = '';
      if (result.marks === 1 && optionIndex === result.enteredCorrectAnswer) {
        feedbackImage = `<img src="${CORRECT_URL}" alt="Correct" style="vertical-align: middle;" />`;
      } else if (result.marks === 0 && optionIndex === result.enteredWrongAnswer) {
        feedbackImage = `<img src="${WRONG_URL}" alt="Incorrect" style="vertical-align: middle;" />`;
      } else if (result.marks === 0 && optionIndex === result.correctAnswerText) {
        feedbackImage = `<img src="${SHOULD_BE_URL}" alt="Correct Answer" style="vertical-align: middle;" />`;
      }

      if (feedbackImage) {
        feedbackCell.innerHTML = feedbackImage;
        feedbackCell.style.display = 'table-cell';
        feedbackCell.style.textAlign = 'center';
        feedbackCell.style.verticalAlign = 'middle';
      }
    });

    const answeredOption = result.marks === 1 ? result.enteredCorrectAnswer : result.enteredWrongAnswer;
    const explanationElement = iframeDoc.getElementById(`TD_Rsn_${answeredOption}`);
    if (explanationElement?.innerHTML && !iframeDoc.getElementById('el-explanation-container')) {
      const container = iframeDoc.createElement('div');
      container.id = 'el-explanation-container';
      container.innerHTML = `
        <hr style='height:1px; background-color:#cfcfcf; border:none; margin:50px 30px 30px;'>
        <p style='font-size:24px; color:#797979; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding:0 30px; margin:0 0 20px'>Explanation</p>
        <p style='font-size:24px; color:#000000; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding:0 30px; margin:0 0 50px'>${explanationElement.innerHTML}</p>`;
      iframeDoc.body.appendChild(container);
    }
  }, []);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe && questionHtml) {
      iframe.srcdoc = injectObjectiveBridge(questionHtml, assetsBaseUrl);
      iframe.onload = () => {
        const iframeDoc = iframe.contentDocument;
        if (!iframeDoc) return;

        const tdElements = iframeDoc.querySelectorAll('[id^="KSD_TD_"]') as NodeListOf<HTMLElement>;
        tdElements.forEach(td => {
          td.style.paddingTop = '0px';
          td.style.paddingRight = "40px";
          td.style.paddingBottom = '0px';
        });

        // NEW — RFC/RFIC preview takes priority over the plain single-answer
        // reveal when this mode is set. Real students and ANSWERS/SOLUTION
        // preview are completely unaffected.
        if (effectivePreviewMode === 'RFC_RFIC') {
          revealRfcRfic(iframeDoc);
        } else if (effectivePreviewMode) {
          revealCorrectAnswer(iframeDoc);
        }

        // The solution state update can coincide with an iframe reload. Restore
        // the already-calculated feedback after the bridge has rebuilt rows.
        if (validationRef.current) {
          setTimeout(() => {
            if (validationRef.current) applyValidationFeedback(iframeDoc, validationRef.current);
          }, 100);
        }
      };
    }
  }, [questionHtml, assetsBaseUrl, effectivePreviewMode, revealCorrectAnswer, revealRfcRfic, applyValidationFeedback]);


  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.data?.type === 'el-option-selected') {
        setSelectedOption(e.data.value);
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  const validateAnswer = useCallback((): ValidationResult | null => {
    if (!effectivePreviewMode && selectedOption === null) {
      showAlert("Please select an answer.");
      return null;
    }

    const iframeDoc = iframeRef.current?.contentDocument;
    if (!iframeDoc) return null;

    let correctAnswer = "";

    const answerKeyInput = iframeDoc.getElementById('KSD_Ans') as HTMLInputElement;
    if (answerKeyInput && answerKeyInput.value) {
      correctAnswer = answerKeyInput.value.trim();
    }
    else {
      const infoEl = iframeDoc.getElementById('KSD_MW_Info') as HTMLInputElement;
      if (infoEl && infoEl.value) {
        const parts = infoEl.value.split('|');
        if (parts.length > 3) {
          correctAnswer = parts[3].trim();
        }
      }
    }

    if (correctAnswer === "") {
      showAlert("Could not verify the answer. The answer key is missing.");
      return null;
    }

    const noOfOptions = iframeDoc.querySelectorAll('tr[id^="KSD_TR_"]').length;

    const isCorrect = selectedOption === correctAnswer;
    const marks = isCorrect ? 1 : 0;

    return {
      marks,
      noOfOptions: noOfOptions || 1,
      enteredCorrectAnswer: isCorrect ? selectedOption || "" : "",
      enteredWrongAnswer: !isCorrect ? selectedOption || "" : "",
      enteredBlankAnswer: "",
      optOrder: buildOptionOrder(iframeRef.current, 'O'),
      scoringMethod: null,
      correctAnswerText: correctAnswer
    };
  }, [selectedOption, iframeRef, showAlert]);


  const getSkipMetadata = useCallback(() => {
    const iframeDoc = iframeRef.current?.contentDocument;
    if (!iframeDoc) return null;

    const noOfOptions = iframeDoc.querySelectorAll('tr[id^="KSD_TR_"]').length;
    if (noOfOptions === 0) return null;

    return {
      noOfOptions,
      optOrder: buildOptionOrder(iframeRef.current, 'O'),
    };
  }, []);

  useImperativeHandle(ref, () => ({
    getAnswer: () => {
      const result = validateAnswer();
      if (!result) return null;

      const { marks, noOfOptions, enteredCorrectAnswer, enteredWrongAnswer, enteredBlankAnswer, optOrder, scoringMethod } = result;
      return { marks, noOfOptions, enteredCorrectAnswer, enteredWrongAnswer, enteredBlankAnswer, optOrder, scoringMethod };
    },
    getSkipMetadata,
  }), [validateAnswer, getSkipMetadata]);

  const playRandomSound = useCallback(async (soundFiles: string[], folder: 'Correct' | 'Incorrect') => {
    const baseUrl = assetsBaseUrl || "https://www.elearnoncloud.com/Storage/assets/";
    if (!soundFiles || soundFiles.length === 0) return;
    const fileName = soundFiles[Math.floor(Math.random() * soundFiles.length)];
    const audioUrl = `${baseUrl}Audio/Question/${folder}/${fileName}`;
    const audio = new Audio(audioUrl);
    try { await audio.play(); } catch (error) { console.error(`Error playing audio from ${audioUrl}:`, error); }
  }, [assetsBaseUrl]);

  const handleClueClick = useCallback(async () => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowClueModal(true);
    setIsClueLoading(true);
    setClueContent("");
    setCurrentClueNo(0);
    setNoOfClues(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';
    const varValuesParam = currentQnMeta?.VarValues || "";

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsClueLoading(false);
      setShowClueModal(false);
      return;
    }

    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

    try {
      const response = await fetch(`${apiUrl}clue/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          varValues: varValuesParam,
        }),
      });

      if (!response.ok) {
        if (response.status === 404) setClueContent("");
        else if (response.status === 401 || response.status === 403) showAlert("Authentication failed.");
        throw new Error(`HTTP error! status: ${response.status}`);
      } else {
        const data = await response.json();
        setClueContent(data.clueHtml || "");
        setClueSeen(true);
      }
    } catch (error) {
      console.error("Error fetching clue:", error);
      if (!(error instanceof Error && (error.message.includes("401") || error.message.includes("403") || error.message.includes("404")))) {
        showAlert("Failed to load the clue.");
      }
      setClueContent("");
    } finally {
      setIsClueLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]);

  const fetchPrincipleContent = async (principleId: string, folderParam: string, countryParam: string) => {
    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

    const response = await fetch(`${apiUrl}principle/`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        folder: folderParam,
        questionNo: principleId,
        country: countryParam,
      }),
    });

    if (!response.ok) throw new Error("Failed");
    return await response.json();
  };

  const handlePrcClick = useCallback(async () => {
    if (!currentQnMeta || !lessonMeta) return;

    const prcString = currentQnMeta.PrincipleNos || "";
    const prcIds = prcString.replace(/"/g, "").split(',').filter((s: string) => s.trim() !== "");

    if (prcIds.length === 0) {
      if (currentQnMeta.NoOfPrc > 0) {
        prcIds.push("1");
      } else {
        showAlert("No principles found for this question.");
        return;
      }
    }

    setShowPrcModal(true);
    setIsPrcLoading(true);
    setPrcContent("");
    setPrincipleList(prcIds);
    setCurrentPrcIndex(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsPrcLoading(false);
      setShowPrcModal(false);
      return;
    }

    try {
      const data = await fetchPrincipleContent(prcIds[0], folderParam, countryParam);
      setPrcContent(data.principleHtml || "");
      setPrcSeen(true);
    } catch (error) {
      console.error("Error fetching principle:", error);
      setPrcContent("");
    } finally {
      setIsPrcLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]);

  const handleSolnClick = useCallback(async (autoExpand = false) => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowSolnModal(true);
    setIsSolnLoading(true);
    setSolnContent("");
    setCurrentSolnNo(0);
    setNoOfSteps(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsSolnLoading(false);
      setShowSolnModal(false);
      return;
    }

    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK ;

    try {
      const response = await fetch(`${apiUrl}solution/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          autoExpand: autoExpand,
        }),
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) showAlert("Authentication failed.");
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setSolnContent(data.solutionHtml || "");
      if (solutionSeen === 'N') setSolutionSeen(1);
    } catch (error) {
      console.error("Error fetching solution:", error);
      if (!(error instanceof Error && (error.message.includes("401") || error.message.includes("403")))) {
        showAlert("Failed to load the solution.");
      }
      setShowSolnModal(false);
    } finally {
      setIsSolnLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, solutionSeen]);

  const handleDbUpdate = useCallback((payload: QuestionPerformancePayload) => {
    return saveQuestionPerformance(payload)
      .then((data) => {
        if (isCompleting && updateSessionPoints) {
          updateSessionPoints(data.pointsEarned || 0);
        }
        return data;
      })
      .catch((error) => {
        console.error("Save Performance Error:", error);
        throw error;
      });
  }, [isCompleting, updateSessionPoints]);

  const handleOkClick = useCallback(async (e: React.MouseEvent<any>) => {
    e.preventDefault();
    if (okClicked || isSubmitting) return;

    let answerData = validateAnswer();

    if (effectivePreviewMode && !answerData) {
      answerData = {
        marks: 1,
        noOfOptions: 0,
        enteredCorrectAnswer: selectedOption || "",
        enteredWrongAnswer: "",
        enteredBlankAnswer: "",
        optOrder: buildOptionOrder(iframeRef.current, 'O'),
        scoringMethod: null,
        correctAnswerText: selectedOption || ""
      };
    }

    if (!answerData) return;

    const { marks, noOfOptions, enteredCorrectAnswer, enteredWrongAnswer, enteredBlankAnswer, optOrder, scoringMethod, correctAnswerText } = answerData;

    const isLastQuestion = currentPage === totalPages;
    const questionAnswerTime = startTime ? Math.floor((new Date().getTime() - startTime.getTime()) / 1000) : 0;
    const hiddenQuestionDataInput = document.getElementById('hidQuestionData') as HTMLInputElement | null;
    const hiddenQuestionData = hiddenQuestionDataInput?.value || '';

    const payload: QuestionPerformancePayload = {
      schoolCode: sessionStorage.getItem('SchoolCode') || '',
      familyCode: sessionStorage.getItem('FamilyCode') || '',
      login: sessionStorage.getItem('Login') || '',
      dicCode: sessionStorage.getItem('SelectedDICFile') || '',
      lsnTestCode: sessionStorage.getItem('LsnTestCode') || '',
      sessionId: sessionId || 1,
      qnNo: currentQnMeta?.QnNo,
      subNo: 0,
      qnType: currentQnMeta?.QnType,
      marks: marks,
      noOfOptions: noOfOptions,
      enteredCorrectAnswer: enteredCorrectAnswer,
      enteredWrongAnswer: enteredWrongAnswer,
      enteredBlankAnswer: enteredBlankAnswer,
      solutionSeen: (typeof solutionSeen === 'number' && solutionSeen > 0) || solutionSeen === 'Y' ? 'Y' : 'N',
      clueSeen: clueSeen,
      principleSeen: prcSeen,
      questionLoadTime: 0,
      questionAnswerTime: questionAnswerTime,
      lastQnInd: currentQnMeta?.LastQnInd || currentPage,
      nextQnData: buildNextQuestionData(lessonMeta?.qns, currentPage),
      dbgShuffledQnsOrder: buildShuffledQuestionsOrder(lessonMeta?.qns),
      allQuestionsCompleted: isCompleting ? 'True' : 'False',
      chapterCode: sessionStorage.getItem('ChapterCode') || '',
      unitCode: sessionStorage.getItem('UnitCode') || '',
      optOrder: optOrder,
      OptOrder: optOrder,
      hiddenQnData: hiddenQuestionData,
      HiddenQnData: hiddenQuestionData,
      hidQuestionData: hiddenQuestionData,
      scoringMethod: scoringMethod,
      hwid: hwid,
      subject: subject,
    };

    // Never persist performance data while in preview mode.
    if (isLastQuestion) {
      setIsSubmitting(true);
      try {
        if (!effectivePreviewMode) {
          await handleDbUpdate(payload);
        }
      } catch (e) {
        console.error("Final submit failed", e);
        showAlert("Error saving progress. Please try again.");
        setIsSubmitting(false);
        return;
      }
      setIsSubmitting(false);
    } else {
      if (!effectivePreviewMode) {
        handleDbUpdate(payload).catch(e => console.error("Background save failed", e));
      }
    }

    const validationResult: ValidationResult = {
      marks,
      noOfOptions,
      enteredCorrectAnswer,
      enteredWrongAnswer,
      enteredBlankAnswer,
      optOrder,
      scoringMethod,
      correctAnswerText,
    };
    validationRef.current = validationResult;
    const iframeDoc = iframeRef.current?.contentDocument;
    if (iframeDoc) applyValidationFeedback(iframeDoc, validationResult);

    if (marks === 1) {
      playRandomSound(correctAudio, 'Correct');
    } else {
      playRandomSound(incorrectAudio, 'Incorrect');

      if (currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0) {
        handleSolnClick(true);
      }
    }

    setOkClicked(true);
  }, [
    okClicked, isSubmitting, validateAnswer, handleSolnClick, currentPage, totalPages,
    startTime, sessionId, currentQnMeta, solutionSeen, clueSeen, prcSeen,
    showAlert, handleDbUpdate, isCompleting, hwid, subject, playRandomSound, correctAudio, incorrectAudio, effectivePreviewMode, applyValidationFeedback
  ]);
  const handleBack = () => {
    const calledFrom = params.get("calledFrom");

    if (calledFrom) {
      const redirectPath = decodeURIComponent(calledFrom);
      window.location.href = redirectPath;
    }
    else if (window.history.length > 1) {
      window.history.back();
    }
  };

  return (
    <>
      {!isInAssessment && (
        <tr id="trQnButtons">
          <td className="QnPanelT">
            <table id="tabQnNav" className="QnPanel2T" style={{ height: "50px" }}>
              <tbody>
                <tr id="trQnOK" className="trQnOKT">
                  <td id="QnPanelIdT" className="QnPanel">&nbsp;</td>
                  <td id="QnPanelId2T" className="QnPanel">
                    <div
                      onClick={!okClicked ? handleBack : undefined}
                      style={{ display: okClicked ? 'none' : 'block', cursor: 'pointer' }}
                    >
                      <div id="imgbtnBack" className="imgbtnBackT">
                        <img
                          src={backSrc}
                          alt="Back"
                          onMouseOver={handleBackMouseOver}
                          onMouseOut={handleBackMouseOut}
                          onMouseDown={handleBackMouseDown}
                          onMouseUp={handleBackMouseUp}
                          className="imgbtnBack2T"
                        />
                      </div>
                    </div>
                  </td>
                  <td id="QnPanelId3T" className="QnPanel">
                    <input
                      type="image"
                      id="imgPrc"
                      src={principle_n}
                      className="imgPrcT"
                      alt="Principle"
                      style={{ display: !okClicked && currentQnMeta?.NoOfPrc && currentQnMeta.NoOfPrc > 0 ? 'inline-block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handlePrcClick(); }}
                    />
                  </td>
                  <td id="QnPanelId4T" className="QnPanel">
                    <input
                      type="image"
                      id="imgClue"
                      src={clue_n}
                      className="imgClueT"
                      alt="Clue"
                      style={{ display: !okClicked && Number(currentQnMeta?.NoOfClues || 0) > 0 ? 'inline-block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handleClueClick(); }}
                    />
                  </td>
                  <td id="QnPanelId5T" className="QnPanel">
                    <input type="image" id="imgSoln" src={solutionSrc} className="imgSolnT" alt="Solution" style={{ display: currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0 ? 'inline-block' : 'none' }} onClick={(e) => { e.preventDefault(); handleSolnClick(false); }} onMouseOver={handleSolutionMouseOver} onMouseOut={handleSolutionMouseOut} onMouseDown={handleSolutionMouseDown} />
                  </td>
                  <td id="QnPanelId5T" className="QnPanel">
                    <a
                      href={`/STUDENT/Tutorials/Tutorial?id=${folderParam}&name=${encodeURIComponent(lessonName ?? '')}&folder=${encodeURIComponent(diccode ?? '')}&calledFrom=${encodeURIComponent(calledFrom ?? '')}&sessionId=${sessionId}&currentPage=${currentPage}`}
                      id="imgbtnTut"
                      className="imgbtnTutT"
                      style={{ display: okClicked ? 'none' : 'inline-block' }}
                    >
                      <img src={tutorials_n} alt="Tutorial" id="imgbtnTut2T" />
                    </a>
                  </td>
                  <td id="QnPanelId6T" className="QnPanel">
                    {isSubmitting ? (
                      <Loading />
                    ) : okClicked ? (
                      currentPage === totalPages ? (
                        <img
                          src={doneSrc}
                          alt="Done"
                          style={{ verticalAlign: 'middle' }}
                          onClick={() => {
                            const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
                            const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
                            const calledFrom = params.get("calledFrom") || "";
                            navigate(
                              `/STUDENT/Tutorials/Result?DicCode=${dicCode}&LsnTestCode=${lsnTestCode}&SessionID=${sessionId}&source=lesson` +
                              (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : "")
                            );
                          }}
                          onMouseOver={() => setDoneSrc(done_o)}
                          onMouseOut={() => setDoneSrc(done_n)}
                        />
                      ) : (
                        <img
                          src={nextSrc}
                          alt="Next"
                          onClick={goToNextPage}
                          onMouseOver={handleNextMouseOver}
                          onMouseOut={handleNextMouseOut}
                          onMouseDown={handleNextMouseDown}
                          onMouseUp={handleNextMouseUp}
                          style={{ display: 'inline-block', cursor: 'pointer', marginTop: '3px' }}
                        />
                      )
                    ) : (
                      <div
                        onClick={handleOkClick}
                        onMouseOver={handleOkMouseOver}
                        onMouseOut={handleOkMouseOut}
                        onMouseDown={handleOkMouseDown}
                        onMouseUp={handleOkMouseUp}
                        style={{ display: 'inline-block', cursor: 'pointer' }}
                      >
                        <img src={okSrc} alt="OK" style={{ marginTop: '3px' }} />
                      </div>
                    )}
                  </td>
                  <td id="QnPanelId7" className="QnPanel">&nbsp;</td>
                </tr>
                <tr id="trQnNext" className="trQnNextT">
                  <td id="tdBN1" className="QnPanel">&nbsp;</td>
                  <td id="tdAnsMsg" className="QnPanel">&nbsp;</td>
                  <td id="tdShowCA" className="QnPanel">&nbsp;</td>
                  <td id="tdAnsSoln" className="QnPanel">
                    <img id="imgSolnAfterAnswering" src={solutionSrc} alt="Solution" onMouseOver={handleSolutionMouseOver} onMouseOut={handleSolutionMouseOut} onMouseDown={handleSolutionMouseDown} />
                  </td>
                  <td id="tdQnNext" className="QnPanel">
                    {okClicked ? (
                      <input type="image" id="imgNextQuestion" src={nextSrc} alt="Next" onClick={goToNextPage} onMouseOver={handleNextMouseOver} onMouseOut={handleNextMouseOut} onMouseDown={handleNextMouseDown} onMouseUp={handleNextMouseUp} style={{ display: okClicked ? 'inline-block' : 'none' }} />
                    ) : (
                      <img id="imgOK" src={okSrc} alt="OK" onClick={handleOkClick} onMouseOver={handleOkMouseOver} onMouseOut={handleOkMouseOut} onMouseDown={handleOkMouseDown} onMouseUp={handleOkMouseUp} className="imgOKT" style={{ display: okClicked ? 'none' : 'inline-block' }} />
                    )}
                  </td>
                  <td id="tdBN" className="QnPanel">&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      )}

      <tr id="triFrame">
        <td id="tdFrameQnT" style={{ padding: 0, height: '100%' }}>
          <div id="divFrameQn" style={{ height: 'calc(95vh - 50px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
            {questionHtml ? (
              <iframe
                id="iFrameQn"
                ref={iframeRef}
                frameBorder={0}
                scrolling="yes"
                className="CssiFrm"
                style={{
                  flex: '1 1 0',
                  width: '100%',
                  height: '100%',
                  minHeight: 0,
                  border: 'none',
                  overflow: 'auto'
                }}
                title="Question Page"
              />
            ) : <Loading />}
          </div>
        </td>
      </tr>

      {showClueModal && (
        <>
          {!showSolnModal && <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowClueModal(false)}></div>}
          <div id="divClue" style={{ display: 'block' }}>
            <table id="tblTitleClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ height: "50px", fontSize: "15px" }}>
              <tbody>
                <tr>
                  <td id="tdClueTitle1" align="left">Clue</td>
                  <td id="tdClueClose" align="right" valign="top">
                    <img id="imgClueClose" src={CloseBtnSrc} alt="Close" onClick={() => setShowClueModal(false)} onMouseOver={handleCloseBtnMouseOver} onMouseOut={handleCloseBtnMouseOut} style={{ cursor: 'pointer', padding: '5px' }} />
                  </td>
                </tr>
              </tbody>
            </table>
            <div id="divFrameClue">
              {isClueLoading ? <Loading /> : (
                <iframe id="iFrameClue" ref={clueIframeRef} title="Clue" srcDoc={clueContent} style={{ width: '100%', border: 'none', minHeight: '80px' }}
                  onLoad={() => {
                    const iframe = clueIframeRef.current;
                    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;
                    try {
                      const divShows = iframe.contentDocument.querySelectorAll("[id^='divShow']");
                      divShows.forEach(div => {
                        (div as HTMLElement).style.padding = "20px";
                      });
                      const cluesInput = iframe.contentDocument.getElementById('NoOfClues') as HTMLInputElement;
                      const totalClues = parseInt(cluesInput?.value || '0', 10);
                      setNoOfClues(totalClues);
                      const clueDivs = iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]');
                      clueDivs.forEach((div, index) => div.style.display = index === 0 ? 'block' : 'none');
                      const firstClueDiv = iframe.contentDocument.getElementById('divShow1');
                      if (firstClueDiv) {
                        const newHeight = firstClueDiv.offsetHeight;
                        iframe.style.height = `${Math.min(newHeight, 300)}px`;
                      } else if (totalClues === 0) {
                        iframe.style.height = '50px';
                      }
                    } catch (e) { console.error("Error inside clue iframe onLoad:", e); }
                  }}
                />
              )}
            </div>
            <table id="tblNavClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
              <tbody>
                <tr>
                  <td style={{ width: '33%' }}>&nbsp;</td>
                  <td style={{ width: '34%' }}>&nbsp;</td>
                  <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                    {!isClueLoading && noOfClues > 1 && currentClueNo < noOfClues - 1 && (
                      <img id="btnClueNext" src={NextStepBtnSrc} alt="Next Clue"
                        onClick={() => {
                          const nextClue = currentClueNo + 1;
                          const iframe = clueIframeRef.current;
                          if (iframe?.contentDocument) {
                            iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]').forEach((div, index) => {
                              div.style.display = index === nextClue ? 'block' : 'none';
                            });
                            setCurrentClueNo(nextClue);
                            const nextClueDiv = iframe.contentDocument.getElementById(`divShow${nextClue + 1}`);
                            if (nextClueDiv) {
                              const newHeight = nextClueDiv.scrollHeight + 20;
                              iframe.style.height = `${Math.min(newHeight, 300)}px`;
                            }
                          }
                        }}
                        onMouseOver={handleNextStepBtnMouseOver} onMouseOut={handleNextStepBtnMouseOut} style={{ cursor: 'pointer' }}
                      />
                    )}
                    {!isClueLoading && (noOfClues <= 1 || currentClueNo === noOfClues - 1) && (
                      <img id="btnClueGotIt" src={GotItBtnSrc} alt="Got It" onClick={() => setShowClueModal(false)} onMouseOver={handleGotItBtnMouseOver} onMouseOut={handleGotItBtnMouseOut} style={{ cursor: 'pointer', display: isClueLoading ? 'none' : 'inline-block' }} />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      {showPrcModal && (
        <>
          <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowPrcModal(false)}></div>

          <div id="divPCS" style={{ display: 'block' }} className="principle">

            <table id="tblTitlePCS" className="principle" cellSpacing="0" cellPadding="0" width="100%">
              <tbody>
                <tr>
                  <td id="tdPCSTitle1" style={{ padding: '2px 2px 2px 30px', color: 'white', fontWeight: 'bold', fontSize: '15px' }}>
                    PRINCIPLE {principleList.length > 1 ? ` ${currentPrcIndex + 1} of ${principleList.length}` : ''}
                  </td>
                  <td id="tdPCSClose" align="right" valign="top">
                    <img
                      id="imgPCSClose"
                      src={CloseBtnSrc}
                      alt="Close"
                      onClick={() => setShowPrcModal(false)}
                      onMouseOver={handleCloseBtnMouseOver}
                      onMouseOut={handleCloseBtnMouseOut}
                      style={{ cursor: 'pointer', padding: '5px', width: '40px', height: '40px', marginRight: '30px' }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div id="divFramePCS">
              {isPrcLoading ? <Loading /> : (
                <iframe
                  id="iFramePrc"
                  ref={prcIframeRef}
                  title="Prc"
                  srcDoc={prcContent}
                  style={{ width: '100%', border: 'none', overflow: 'hidden', display: 'block' }}
                  onLoad={() => {
                    const iframe = prcIframeRef.current;
                    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;

                    setTimeout(() => {
                      if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                      const contentHeight = iframe.contentDocument.body.scrollHeight + 20;

                      const divPCS = document.getElementById('divPCS') as HTMLElement;
                      const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                      const navTable = document.getElementById('tblNavPCS') as HTMLElement;
                      if (divPCS && titleTable && navTable) {
                        const maxModalHeight = window.innerHeight * 0.8;
                        const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;
                        if (contentHeight > maxIframeHeight) {

                          iframe.style.height = `${maxIframeHeight}px`;
                          iframe.style.overflowY = 'auto';
                        } else {

                          iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                          iframe.style.overflowY = 'hidden';
                        }
                      } else {
                        iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                      }
                    }, 50);
                  }}
                />
              )}
            </div>

            <table id="tblNavPCS" className="principle" cellSpacing="0" cellPadding="0" width="100%" style={{ height: "50px" }}>
              <tbody>
                <tr style={{ backgroundColor: '#F2F2F2', paddingRight: '10px' }}>
                  <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                    {currentPrcIndex > 0 && (
                      <input
                        type='button'
                        value='PREVIOUS'
                        onClick={() => {
                          const prevIndex = currentPrcIndex - 1;
                          setCurrentPrcIndex(prevIndex);
                          fetchPrincipleContent(principleList[prevIndex], params.get('folder') || '', params.get('country') || 'Australia');
                        }}
                        style={{
                          fontWeight: 'bold',
                          color: 'White',
                          fontSize: '12pt',
                          borderStyle: 'none',
                          backgroundColor: 'maroon',
                          cursor: 'pointer',
                          padding: '5px 10px'
                        }}
                      />
                    )}
                  </td>

                  <td style={{ width: '34%' }}>&nbsp;</td>

                  <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                    {currentPrcIndex < principleList.length - 1 ? (
                      <img
                        src={NextStepBtnSrc}
                        alt="Next"
                        onClick={() => {
                          const nextIndex = currentPrcIndex + 1;
                          setCurrentPrcIndex(nextIndex);
                          fetchPrincipleContent(principleList[nextIndex], params.get('folder') || '', params.get('country') || 'Australia');
                        }}
                        onMouseOver={handleNextStepBtnMouseOver}
                        onMouseOut={handleNextStepBtnMouseOut}
                        style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                      />
                    ) : (
                      <img
                        src={GotItBtnSrc}
                        id="imgGotIt"
                        alt="Got It"
                        onClick={() => setShowPrcModal(false)}
                        onMouseOver={handleGotItBtnMouseOver}
                        onMouseOut={handleGotItBtnMouseOut}
                        style={{ cursor: 'pointer', width: '100px', height: '40px', verticalAlign: "middle" }}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      {showSolnModal && (
        <>
          <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => { setShowSolnModal(false); setCurrentSolnNo(0); }}></div>
          <div id="divPCS" style={{ display: 'block' }}>
            <table id="tblTitlePCS" className="solution" cellSpacing="0" cellPadding="0" width="100%">
              <tbody>
                <tr>
                  <td id="tdPCSTitle1">Step by step solution</td>
                  <td id="tdPCSClose" align="right" valign="top">
                    <img id="imgPCSClose" src={CloseBtnSrc} alt="Close" onClick={() => { setShowSolnModal(false); setCurrentSolnNo(0); }} onMouseOver={handleCloseBtnMouseOver} onMouseOut={handleCloseBtnMouseOut} style={{ cursor: 'pointer', padding: '5px' }} />
                  </td>
                </tr>
              </tbody>
            </table>
            <div id="divFramePCS">
              {isSolnLoading ? <Loading /> : (
                <iframe id="iFrameSolution" ref={solnIframeRef} title="Solution" srcDoc={solnContent} style={{ width: '100%', border: 'none', minHeight: '50px' }}
                  onLoad={() => {
                    const iframe = solnIframeRef.current;
                    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) {
                      console.error("Iframe document or window not ready in onLoad.");
                      return;
                    }
                    try {
                      const iframeDoc = iframe.contentDocument;

                      const style = iframeDoc.createElement('style');
                      style.textContent = `
                          table[id^="tblSol"] p,
                          table[id^="tblSol"] table,
                          table[id^="tblSol"] font {
                              margin: 0 !important;
                              padding: 0 !important;
                              line-height: normal !important;
                          }
                          tr[id^="trSolStepLHS"] {
                              display: table-row;
                              background-color: rgb(255, 255, 255);
                              background-image: none;
                          }
                          tr[id^="trSolStepLHS"] > td:first-child {
                              width: 50% !important;
                              max-width: 50% !important;
                              vertical-align: top !important;
                              padding: 0px !important;
                              box-sizing: border-box !important;
                          }
                          tr[id^="trSolStepLHS"] > td:nth-child(2) {
                              width: 50% !important;
                              max-width: 50% !important;
                              vertical-align: middle !important;
                              text-align: center !important;
                              padding: 0px !important;
                              box-sizing: border-box !important;
                          }
                          tr[id^="trSolStepLHS"] td * {
                              font-size: 24px !important;
                              font-family: Arial !important;
                              color: black !important;
                              font-weight: normal !important;
                              line-height: normal !important;
                          }
                          tr[id^="trSolStepLHS"] > td:first-child > font:first-child {
                              font-weight: bold !important;
                              margin-bottom: 0px !important;
                              display: block !important;
                          }
                          tr[id^="trSolStepLHS"] img {
                              max-width: 100% !important;
                              height: auto !important;
                          }
                          tr[id^="trSolStepLHS"] table {
                              width: 100% !important;
                              border-collapse: collapse !important;
                          }
                          body {
                              overflow-x: hidden !important;
                              margin: 0 !important;
                              padding: 0 !important;
                          }
                      `;
                      if (iframeDoc.head) {
                        iframeDoc.head.appendChild(style);
                      }

                      const stepsInput = iframeDoc.getElementById('NoOfSteps') as HTMLInputElement;
                      const totalSteps = parseInt(stepsInput?.value || '0', 10);
                      setNoOfSteps(totalSteps);

                      const isAutoExpanded = iframeDoc.getElementById('IsAutoExpanded');

                      const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');

                      stepRows.forEach((step, index) => {
                        if (index === 0 || isAutoExpanded) {
                          step.style.display = 'table-row';
                        } else {
                          step.style.display = 'none';
                        }
                      });

                      if (totalSteps === 0) {
                        iframe.style.height = '50px';
                      }

                      setTimeout(() => {
                        if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                        iframe.style.height = '10px';
                        const contentHeight = iframe.contentDocument.body.scrollHeight;

                        const divPCS = document.getElementById('divPCS') as HTMLElement;
                        const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                        const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                        if (divPCS && titleTable && navTable) {
                          const chromeHeight = titleTable.offsetHeight + navTable.offsetHeight;
                          const maxTotalHeight = window.innerHeight * 0.4;
                          const maxIframeHeight = maxTotalHeight - chromeHeight;

                          if (contentHeight > maxIframeHeight) {
                            iframe.style.height = `${maxIframeHeight}px`;
                            iframe.style.overflowY = 'auto';
                          } else {
                            iframe.style.height = `${Math.max(contentHeight, 50)}px`;
                            iframe.style.overflowY = 'hidden';
                          }
                        }

                        if (isAutoExpanded) {
                          setCurrentSolnNo(totalSteps - 1);
                          if (solutionSeen !== 'Y') {
                            setSolutionSeen('Y');
                          }
                          iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);
                        }
                      }, 50);

                      iframeDoc.querySelectorAll<HTMLImageElement>('img[id^="KsdImg"]').forEach(img => {
                        img.onclick = () => {
                          const index = img.id.substring(6);
                          const ksdDiv = iframeDoc.getElementById(`KsdDiv${index}`);
                          const content = ksdDiv?.getAttribute('data-ksd-content');
                          const parentTd = img.closest('td');
                          if (content && parentTd && img.getAttribute('alt') === '1') {
                            parentTd.innerHTML = content;
                            img.setAttribute('alt', '2');
                          }
                        };
                      });

                    } catch (e) {
                      console.error("Error inside solution iframe onLoad:", e);
                    }
                  }}
                />
              )}
            </div>
            <table id="tblNavPCS" className="solution" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
              <tbody>
                <tr>
                  <td align="left" style={{ width: '33%', paddingLeft: '15px' }}></td>
                  <td style={{ width: '34%' }}>&nbsp;</td>
                  <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                    {!isSolnLoading && noOfSteps > 0 && currentSolnNo < noOfSteps - 1 && (
                      <img id="btnPCSNext" src={NextStepBtnSrc} alt="Next Step"
                        onClick={() => {
                          const nextStep = currentSolnNo + 1;
                          const iframe = solnIframeRef.current;

                          if (iframe?.contentDocument?.body) {
                            const iframeDoc = iframe.contentDocument;

                            const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                            if (nextStep >= stepRows.length) return;

                            const nextStepElement = stepRows[nextStep];
                            nextStepElement.style.display = 'table-row';

                            setTimeout(() => {
                              const divPCS = document.getElementById('divPCS');
                              const titleTable = document.getElementById('tblTitlePCS');
                              const navTable = document.getElementById('tblNavPCS');

                              if (divPCS && titleTable && navTable && iframe) {
                                const currentModalHeight = divPCS.offsetHeight;
                                const thresholdHeight = window.innerHeight * 0.3;
                                const capHeight = window.innerHeight * 0.4;

                                const chromeHeight = titleTable.offsetHeight + navTable.offsetHeight;

                                const currentIframeHeight = iframe.offsetHeight;
                                const addedContentHeight = nextStepElement.scrollHeight;
                                const newDesiredIframeHeight = currentIframeHeight + addedContentHeight;

                                if (currentModalHeight < thresholdHeight) {
                                  iframe.style.height = `${newDesiredIframeHeight}px`;
                                  iframe.style.overflowY = 'hidden';
                                } else {
                                  const maxIframeHeight = capHeight - chromeHeight;
                                  iframe.style.height = `${maxIframeHeight}px`;
                                  iframe.style.overflowY = 'auto';
                                }

                                setTimeout(() => {
                                  iframe.contentWindow?.scrollTo(0, iframe.contentDocument!.body.scrollHeight);
                                }, 50);
                              }
                            }, 10);

                            setCurrentSolnNo(nextStep);
                            if (solutionSeen !== 'Y') {
                              setSolutionSeen(nextStep + 1);
                            }
                          }
                        }}
                        onMouseOver={handleNextStepBtnMouseOver} onMouseOut={handleNextStepBtnMouseOut} style={{ cursor: 'pointer' }}
                      />
                    )}
                    {!isSolnLoading && (noOfSteps === 0 || currentSolnNo === noOfSteps - 1) && (
                      <img id="btnPCSClose" src={GotItBtnSrc} alt="Got It"
                        onClick={() => { setShowSolnModal(false); setCurrentSolnNo(0); setSolutionSeen('Y'); }}
                        onMouseOver={handleGotItBtnMouseOver} onMouseOut={handleGotItBtnMouseOut}
                        style={{ cursor: 'pointer', display: isSolnLoading ? 'none' : 'inline-block' }}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default forwardRef(OQns);
